'use client';

import { useEffect, useState } from 'react';

import { ENGAGE_THINKING_PENCIL_AFTER_MS } from '@/lib/engage/chat-ui-message';

/**
 * True after `delayMs` while `isWaiting` stays true. Resets when waiting stops
 * or a new wait starts. Timer callback setState only — no sync setState in the
 * effect body.
 */
export function useThinkingPencilAfterDelay(
  isWaiting: boolean,
  delayMs: number = ENGAGE_THINKING_PENCIL_AFTER_MS,
): boolean {
  const [waitingKey, setWaitingKey] = useState(isWaiting);
  const [showPencil, setShowPencil] = useState(false);
  if (isWaiting !== waitingKey) {
    setWaitingKey(isWaiting);
    setShowPencil(false);
  }

  useEffect(() => {
    if (!isWaiting) return undefined;
    const id = window.setTimeout(() => {
      setShowPencil(true);
    }, delayMs);
    return () => {
      window.clearTimeout(id);
    };
  }, [isWaiting, delayMs]);

  return isWaiting && showPencil;
}
